var _linearGradient, _path, _path2, _linearGradient2, _path3, _linearGradient3, _path4, _linearGradient4, _path5, _linearGradient5, _path6, _linearGradient6, _path7, _linearGradient7, _path8, _linearGradient8, _path9, _linearGradient9, _path10, _radialGradient, _path11, _radialGradient2, _path12, _radialGradient3, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8FacialRecognition502(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "WnjOvxUuNSzd69nJXsTZNa",
    x1: 16.553,
    x2: 30.905,
    y1: -130.177,
    y2: -102.253,
    gradientTransform: "translate(-.022 133.794)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d61a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16528c"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#WnjOvxUuNSzd69nJXsTZNa)",
    d: "M42,24.965L6.013,25L6,13.019c-0.004-3.861,3.126-6.994,6.99-6.998L17.997,6H30h4.983 c3.865-0.004,7,3.123,7.004,6.984L42,24.965z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#b52858",
    d: "M6,25.076l35.992-0.035l0.008,5l-3,9L30.003,42l-11.985-0.008L9,39.041l-2.996-8.997L6,25.076z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "WnjOvxUuNSzd69nJXsTZNb",
    x1: -360.231,
    x2: -351.217,
    y1: -362.891,
    y2: -362.891,
    gradientTransform: "translate(389.237 402.891)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#199ae0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#1898de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    stopColor: "#1590d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#1083c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.982,
    stopColor: "#0870b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076cb3"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#WnjOvxUuNSzd69nJXsTZNb)",
    d: "M39.014,38l-8.013,0.007c-0.553,0.001-1.002,0.448-1.001,0.999L30.003,42l8.015-0.008 L39.014,38z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "WnjOvxUuNSzd69nJXsTZNc",
    x1: 37.865,
    x2: 42.066,
    y1: -103.913,
    y2: -92.007,
    gradientTransform: "translate(-.022 133.794)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bdef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ea2e4"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#WnjOvxUuNSzd69nJXsTZNc)",
    d: "M38,31.004L38.011,42l3.406-3.416C41.791,38.209,42.001,37.7,42,37.17L41.993,30l-2.996,0.003 C38.446,30.004,38,30.452,38,31.004z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "WnjOvxUuNSzd69nJXsTZNd",
    x1: -457.72,
    x2: -448.707,
    y1: 882.54,
    y2: 882.54,
    gradientTransform: "rotate(180 -219.297 445.27)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#199ae0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#1898de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    stopColor: "#1590d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#1083c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.982,
    stopColor: "#0870b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076cb3"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#WnjOvxUuNSzd69nJXsTZNd)",
    d: "M8.987,10l8.012-0.007C17.552,9.992,18.001,9.545,18,8.994L17.997,6L9.983,6.008L8.987,10z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "WnjOvxUuNSzd69nJXsTZNe",
    x1: -59.707,
    x2: -55.507,
    y1: 1141.479,
    y2: 1153.38,
    gradientTransform: "rotate(180 -24.732 579.912)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bdef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ea2e4"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#WnjOvxUuNSzd69nJXsTZNe)",
    d: "M10,16.995V6L6.583,9.417C6.209,9.791,5.999,10.3,6,10.831L6.007,18l2.996-0.003 C9.554,17.995,10,17.547,10,16.995z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "WnjOvxUuNSzd69nJXsTZNf",
    x1: -482.06,
    x2: -473.046,
    y1: -363.26,
    y2: -363.26,
    gradientTransform: "matrix(-1 .00096 .00096 1 -462.699 403.717)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#199ae0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#1898de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    stopColor: "#1590d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#1083c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.982,
    stopColor: "#0870b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076cb3"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#WnjOvxUuNSzd69nJXsTZNf)",
    d: "M9,38.007L17.012,38c0.553-0.001,1.002,0.446,1.003,0.997l0.003,2.995L10.004,42L9,38.007z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "WnjOvxUuNSzd69nJXsTZNg",
    x1: -84.22,
    x2: -80.016,
    y1: -103.934,
    y2: -92.025,
    gradientTransform: "matrix(-1 .00096 .00096 1 -73.958 133.871)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bdef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ea2e4"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#WnjOvxUuNSzd69nJXsTZNg)",
    d: "M9.989,31L10,42l-3.408-3.411c-0.374-0.375-0.585-0.883-0.585-1.414L6,30.003L8.991,30 C9.541,30,9.989,30.448,9.989,31z"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "WnjOvxUuNSzd69nJXsTZNh",
    x1: -336.204,
    x2: -327.208,
    y1: 882.294,
    y2: 882.294,
    gradientTransform: "matrix(1 -.00096 -.00096 -1 365.77 889.977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#199ae0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#1898de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    stopColor: "#1590d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#1083c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.982,
    stopColor: "#0870b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076cb3"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#WnjOvxUuNSzd69nJXsTZNh)",
    d: "M39,10h-7.998c-0.551,0.001-0.998-0.446-0.999-0.997L30,6h8L39,10z"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "WnjOvxUuNSzd69nJXsTZNi",
    x1: 61.905,
    x2: 66.108,
    y1: 1141.62,
    y2: 1153.53,
    gradientTransform: "matrix(1 -.00096 -.00096 -1 -22.971 1159.824)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bdef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ea2e4"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#WnjOvxUuNSzd69nJXsTZNi)",
    d: "M38.011,17L38,6l3.408,3.411c0.374,0.375,0.585,0.883,0.585,1.414L42,17.997L39.008,18 C38.458,18,38.011,17.552,38.011,17z"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "WnjOvxUuNSzd69nJXsTZNj",
    cx: 23.174,
    cy: 21.506,
    r: 17.627,
    gradientTransform: "matrix(1 0 0 -1 0 48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcf54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#fdcb4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#f7c13a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0b421"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#WnjOvxUuNSzd69nJXsTZNj)",
    d: "M32.31,22.78V25H15.69v-2.22c0-8.86,4.21-9.49,8.31-9.49S32.31,13.92,32.31,22.78z"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "WnjOvxUuNSzd69nJXsTZNk",
    cx: -22.415,
    cy: -103.747,
    r: 26.691,
    gradientTransform: "translate(35.866 104.997) scale(.8816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c26715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#b85515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad3f16"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#WnjOvxUuNSzd69nJXsTZNk)",
    d: "M24,12.503c-4.019,0-4.615,1.51-4.615,1.51c-1.634,0.241-4.615,2.634-4.615,5.37 c0,1.527,0.245,2.655,0.923,6.462c0.503-6.042,2.076-8.308,3.692-8.308c1.17,0,2.098,0.923,4.615,0.923 c2.126,0,2.654-0.923,4.615-0.923c2.769,0,3.692,7.355,3.692,8.308c0.555-2.778,0.923-5.128,0.923-6.462 C33.231,16.218,29.731,12.503,24,12.503z"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "WnjOvxUuNSzd69nJXsTZNl",
    cx: -29.837,
    cy: -101.96,
    r: 30.829,
    gradientTransform: "matrix(.8431 0 0 .8816 47.833 104.997)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c26715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#b85515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad3f16"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#WnjOvxUuNSzd69nJXsTZNl)",
    d: "M24.202,12c-3.844,0-4.815,2.014-4.815,2.014c-0.039,1.07,0.482,2.014,0.482,2.014 s0.702,1.51,4.708,1.51c2.418,0,5.885-1.509,5.885-5.538C30.462,12,29.683,12,24.202,12z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5749a",
    d: "M33.67,25.44l-0.32,1.57c-0.08,0.39-0.48,0.68-0.96,0.68h-0.65V25h1.92 C33.7,25.14,33.7,25.29,33.67,25.44z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5749a",
    d: "M16.26,25v2.69h-0.65c-0.48,0-0.88-0.29-0.96-0.68l-0.32-1.57c-0.03-0.15-0.03-0.3,0.01-0.44H16.26z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff9cbe",
    d: "M32.31,27.69v1.27c0,3.16-4.99,7.04-8.31,7.04s-8.31-3.88-8.31-7.04v-1.27L15.665,25H32.31V27.69z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf1928",
    d: "M4,26c-0.552,0-0.999-0.438-1-0.98s0.446-0.981,0.999-0.982l40-0.038H44c0.552,0,0.999,0.438,1,0.98 s-0.447,1.019-1,1.02H4L4,26z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8FacialRecognition502);
export default __webpack_public_path__ + "static/media/icons8-facial-recognition-50-2.968e5b790c78252ddd11a8e1b851a3cb.svg";
export { ForwardRef as ReactComponent };